import { FormConfigProps } from '../../../constants/constants';

export const commonSubjectConfig: Record<string, FormConfigProps> = {
  forOpenEndedQuestions: {
    label: 'Atviro tipo klausimuose:',
    value: 'forOpenEndedQuestions',
    children: {
      sentenceStartersProvided: {
        label: 'pateikiama sakinio pradžia',
        value: 'sentenceStartersProvided',
        paddingLeft: 24,
      },
      supportingWordsProvided: {
        label: 'pateikiami atraminiai žodžiai',
        value: 'supportingWordsProvided',
        paddingLeft: 24,
      },
    },
  },
  otherMethod: {
    label: 'kita:',
    value: 'otherMethod',
    isInput: true,
  },
};
